import React from 'react';
import get from "lodash/get";
import PropTypes from "prop-types";

import { viewProps } from '~/ui/Views/views';
import { ScrollView, VFlexPropagate } from '~/native-ui';

export class MaybeScrollableView extends React.PureComponent {
    static propTypes = {
        view: PropTypes.string.isRequired
    }
    
    get component() {
        return get(viewProps, `${this.props.view}.scrollable`, true) ? ScrollView : VFlexPropagate
    }
    
    render() {
        return React.createElement(this.component, {
            _contentContainerStyle: { minHeight: "100%" },
            children: this.props.children || null
        }) 
    }
}